"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const usa_character_count_1 = __importDefault(require("@uswds/uswds/js/usa-character-count"));
function CharacterCount({ children, target }) {
    const containerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const containerEl = containerRef.current;
        if (!containerEl)
            return;
        // add the .usa-character-count__field class to the target input
        const input = containerEl.querySelector(`#${target}`);
        input.classList.add('usa-character-count__field');
        // call USWDS's `on` function to initialize the component
        usa_character_count_1.default.on(containerEl);
        // on dismount, call USWDS's `off` function to cleanup the component
        return () => {
            usa_character_count_1.default.off(containerEl);
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { className: "bah-uswds-character-count", ref: containerRef, children: (0, jsx_runtime_1.jsxs)("div", { className: "usa-character-count", children: [children, (0, jsx_runtime_1.jsx)("span", { id: `character-count--${target}`, className: "usa-hint usa-character-count__message", "aria-live": "polite" })] }) }));
}
exports.default = CharacterCount;
